import script from "./BaseElement.vue?vue&type=script&lang=ts"
export * from "./BaseElement.vue?vue&type=script&lang=ts"

export default script